/* eslint-disable */
import { ASSISTED_USERS_MYSELF } from '@ringcentral-integration/commons/modules/RcVideo';
export default {
  scheduleFor: '次のユーザーに代わってスケジュール：',
  scheduleForAssistedUser: '{userName}に代わって会議設定を更新します。',
  scheduleForGuidance:
    '別の人のためにスケジュールしますか？\n1. Outlook予定表を開きます。\n2. ドロップダウンからスケジュールするメンバーを選択します。\n',
  scheduleForGuidanceMore: '詳細を確認',
  meetingSettings: '会議設定',
  meetingSettingsDescription: '更新はこの会議にのみ適用されます。',
  [ASSISTED_USERS_MYSELF]: '自分',
  waitingRoomTitle: '待機ルームを使用',
  waitingRoomDescription:
    '参加者はあなたが許可するまで待機します。面接や外部の出席者の場合に最適です。',
  waitingRoomNotCoworker: '社外ユーザー',
  waitingRoomGuest: 'サインインしていないユーザー',
  waitingRoomAll: 'すべての参加者',
  enterPassword: 'パスワードを入力',
  onlyJoinAfterMe: 'あなたが参加した後に会議を開始',
  allowJoinBeforeHostDescription:
    '会話が早く始まらないように、会議はあなたが参加した後に開始されます。',
  requirePassword: 'パスワードを要求',
  requirePasswordDescription:
    '会議を安全に保ちます。このリンクを使用するとパスワードの入力を求められません。',
  password: 'パスワード：',
  passwordEmptyError: '会議パスワードが必要です',
  passwordInvalidError:
    'パスワードは1～10文字で英数字を使用できます。記号は使用できません',
  passwordHintText:
    'パスワードは1～10文字で英数字を使用できます。記号は使用できません。',
  usePersonalMeetingIdInstead: '個人会議リンクを使用',
  allowMeetingAccess: '参加できるユーザーを管理',
  anyoneWithLink: 'リンクを知っている人',
  signedInUsers: '{shortName}アカウントのみ',
  signedInCoWorkers: '同僚のみ',
  passwordLabel: 'パスワード',
  edit: '編集',
  editSettings: '設定を編集',
  lockTooltip: 'この設定は会社の管理者によって管理されています',
  cancel: 'キャンセル',
  update: '更新',
  pmiSettingsTitle: '個人会議の設定',
  pmiSettingsDescription:
    '個人会議リンクで参加できるユーザーと参加方法を設定します。',
} as const;

// @key: @#@"scheduleFor"@#@ @source: @#@"Schedule on behalf of"@#@
// @key: @#@"scheduleForAssistedUser"@#@ @source: @#@"Update meetings settings on behalf of {userName}."@#@
// @key: @#@"scheduleForGuidance"@#@ @source: @#@"Scheduling for someone else?\n1. Make sure you're on their Outlook calendar.\n2. From the dropdown, select the person you're scheduling for.\n"@#@
// @key: @#@"scheduleForGuidanceMore"@#@ @source: @#@"Learn details"@#@
// @key: @#@"meetingSettings"@#@ @source: @#@"Meeting settings"@#@
// @key: @#@"meetingSettingsDescription"@#@ @source: @#@"Updates will apply to this meeting only."@#@
// @key: @#@"ASSISTED_USERS_MYSELF"@#@ @source: @#@"Myself"@#@
// @key: @#@"waitingRoomTitle"@#@ @source: @#@"Use waiting room"@#@
// @key: @#@"waitingRoomDescription"@#@ @source: @#@"Participants wait until you admit them. Great for interviews or outside attendees."@#@
// @key: @#@"waitingRoomNotCoworker"@#@ @source: @#@"For anyone outside my company"@#@
// @key: @#@"waitingRoomGuest"@#@ @source: @#@"For anyone not signed in"@#@
// @key: @#@"waitingRoomAll"@#@ @source: @#@"For all participants"@#@
// @key: @#@"enterPassword"@#@ @source: @#@"Enter Password"@#@
// @key: @#@"onlyJoinAfterMe"@#@ @source: @#@"Start meeting after you join"@#@
// @key: @#@"allowJoinBeforeHostDescription"@#@ @source: @#@"The meeting will start after you join to prevent early conversations."@#@
// @key: @#@"requirePassword"@#@ @source: @#@"Require password"@#@
// @key: @#@"requirePasswordDescription"@#@ @source: @#@"Keep your meeting secure. Anyone using the link won't be prompted for a password."@#@
// @key: @#@"password"@#@ @source: @#@"Password:"@#@
// @key: @#@"passwordEmptyError"@#@ @source: @#@"Meeting password required"@#@
// @key: @#@"passwordInvalidError"@#@ @source: @#@"Your password must be 1-10 letters and numbers long but cannot contain symbols"@#@
// @key: @#@"passwordHintText"@#@ @source: @#@"Your password should be 1-10 letters and numbers long, but can not contain symbols."@#@
// @key: @#@"usePersonalMeetingIdInstead"@#@ @source: @#@"Use personal meeting link"@#@
// @key: @#@"allowMeetingAccess"@#@ @source: @#@"Manage who can join"@#@
// @key: @#@"anyoneWithLink"@#@ @source: @#@"Anyone with link"@#@
// @key: @#@"signedInUsers"@#@ @source: @#@"Only {shortName} accounts"@#@
// @key: @#@"signedInCoWorkers"@#@ @source: @#@"Only my coworkers"@#@
// @key: @#@"passwordLabel"@#@ @source: @#@"Password"@#@
// @key: @#@"edit"@#@ @source: @#@"Edit"@#@
// @key: @#@"editSettings"@#@ @source: @#@"Edit settings"@#@
// @key: @#@"lockTooltip"@#@ @source: @#@"This setting is managed by your company admin"@#@
// @key: @#@"cancel"@#@ @source: @#@"Cancel"@#@
// @key: @#@"update"@#@ @source: @#@"Update"@#@
// @key: @#@"pmiSettingsTitle"@#@ @source: @#@"Personal meeting settings"@#@
// @key: @#@"pmiSettingsDescription"@#@ @source: @#@"Set who can join and how for your personal meeting link."@#@
